var __extends = this && this.__extends || function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { getBexApiContext } from 'bernie-context';
import { NOOP_LOGGER } from 'bernie-logger';
import { Store } from 'bernie-plugin-mobx';
import { computed, observable } from 'mobx';
import { ActivityDetailViewOptions } from '../common/__generated__/api/types';
import { equals } from '../helpers/common-helper';
import { activityDateRangeInput } from '../helpers/controller-date-helper';
import { getIsoFormatDateFromDateString } from '../helpers/date-helper';
var DEFAULT_COMMENTS_LENGTH = 10;
var COMMENTS_START_INDEX = 0;
var MCTC_MOD_ENABLED = 2;
var DetailCriteriaStore = /** @class */function (_super) {
  __extends(DetailCriteriaStore, _super);
  function DetailCriteriaStore(state, logger, marketingInfo) {
    if (state === void 0) {
      state = {};
    }
    if (logger === void 0) {
      logger = NOOP_LOGGER;
    }
    var _this = _super.call(this, state, logger) || this;
    _this.detailQuery = {};
    _this.offerFilters = {};
    _this.selectedDate = null;
    _this.offerId = '';
    _this.localDateFormat = 'yyyy-MM-dd';
    _this.activityId = '';
    _this.commentsIndex = COMMENTS_START_INDEX;
    _this.context = {};
    _this.dateRange = null;
    _this.defaultCommentsLength = DEFAULT_COMMENTS_LENGTH;
    _this.queryStringUpdated = true;
    _this.recommendedActivity = false;
    if (marketingInfo) {
      _this.marketingInfo = marketingInfo;
    }
    return _this;
  }
  DetailCriteriaStore.prototype.hydrate = function (data) {
    this.detailQuery = __assign({}, data.detailQuery);
    this.context = __assign({}, data.context);
    this.activityId = data.activityId;
    this.selectedDate = data.selectedDate;
    this.queryStringUpdated = data.queryStringUpdated;
    this.localDateFormat = data.localDateFormat;
    this.offerFilters = data.offerFilters;
    this.marketingInfo = data.marketingInfo;
    delete data.marketingInfo;
  };
  DetailCriteriaStore.prototype.isQueryStringUpdated = function () {
    return this.queryStringUpdated;
  };
  DetailCriteriaStore.prototype.setQueryStringUpdated = function (queryStringUpdated) {
    this.queryStringUpdated = queryStringUpdated;
  };
  DetailCriteriaStore.prototype.isRecommendedActivity = function () {
    return this.recommendedActivity;
  };
  DetailCriteriaStore.prototype.setRecommendedActivity = function (recommendedActivity) {
    this.recommendedActivity = recommendedActivity;
  };
  DetailCriteriaStore.prototype.resetDetailCriteriaStore = function () {
    this.detailQuery = {};
    this.activityId = '';
    this.selectedDate = null;
    this.queryStringUpdated = true;
  };
  DetailCriteriaStore.prototype.setContext = function (context) {
    this.context = getBexApiContext(context);
  };
  DetailCriteriaStore.prototype.changedQueryKeys = function (query, activityId) {
    var _this = this;
    var detailKeys = ['location', 'endDate', 'startDate', 'rid', 'swp'];
    var changedKeys = [];
    detailKeys.forEach(function (key) {
      if (_this.isQueryKeyDifferent(query, key)) {
        changedKeys.push(key);
      }
    });
    if (!equals(activityId, this.activityId)) {
      changedKeys.push('activityId');
    }
    return changedKeys;
  };
  Object.defineProperty(DetailCriteriaStore.prototype, "detailVariables", {
    get: function () {
      return {
        context: this.context,
        destination: this.activityDestinationInput,
        dateRange: this.activityDateRangeInput,
        activityId: this.activityId,
        marketing: this.marketing,
        detailsViewOptions: this.detailsViewOptions
      };
    },
    enumerable: false,
    configurable: true
  });
  DetailCriteriaStore.prototype.setActivityId = function (id) {
    this.activityId = id;
  };
  DetailCriteriaStore.prototype.getActivityId = function () {
    return this.activityId;
  };
  DetailCriteriaStore.prototype.isQueryKeyDifferent = function (query, key) {
    if (key === 'startDate' || key === 'endDate') {
      if (query[key] !== '' && this.detailQuery["".concat(key)] !== '') {
        return !equals(getIsoFormatDateFromDateString(query[key], this.localDateFormat), getIsoFormatDateFromDateString(this.detailQuery["".concat(key)], this.localDateFormat));
      }
      return true;
    }
    return !equals(query[key], this.detailQuery[key]);
  };
  Object.defineProperty(DetailCriteriaStore.prototype, "activityDestinationInput", {
    get: function () {
      return {
        regionName: this.detailQuery.location,
        regionId: this.detailQuery.rid
      };
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(DetailCriteriaStore.prototype, "marketing", {
    get: function () {
      var marketingInfo = {};
      if (this.marketingInfo) {
        marketingInfo.sem = this.marketingInfo.sem;
        marketingInfo.semdtl = this.marketingInfo.semdtl;
      }
      if (this.lxModEnabled) {
        marketingInfo.mctc = MCTC_MOD_ENABLED;
      }
      return marketingInfo;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(DetailCriteriaStore.prototype, "lxModEnabled", {
    get: function () {
      var mctcIsSet = this.detailQuery.mctc ? this.detailQuery.mctc === MCTC_MOD_ENABLED.toString() : false;
      return mctcIsSet || typeof document !== 'undefined' && document.cookie.includes('lx_mod_enabled=true');
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(DetailCriteriaStore.prototype, "activityDateRangeInput", {
    get: function () {
      var dateRange = activityDateRangeInput(this.detailQuery, this.localDateFormat);
      if (!dateRange && this.selectedDate) {
        var bexSelectedDate = {
          day: this.selectedDate.day,
          month: this.selectedDate.month,
          year: this.selectedDate.year
        };
        dateRange = {
          startDate: bexSelectedDate,
          endDate: bexSelectedDate
        };
      }
      return dateRange;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(DetailCriteriaStore.prototype, "detailsViewOptions", {
    get: function () {
      var detailsViewOptions = [];
      if (this.detailQuery.swp !== 'off') {
        detailsViewOptions.push(ActivityDetailViewOptions.SHOP_WITH_POINTS);
      }
      return detailsViewOptions.length > 0 ? detailsViewOptions : null;
    },
    enumerable: false,
    configurable: true
  });
  __decorate([observable], DetailCriteriaStore.prototype, "detailQuery", void 0);
  __decorate([observable], DetailCriteriaStore.prototype, "offerFilters", void 0);
  __decorate([observable], DetailCriteriaStore.prototype, "selectedDate", void 0);
  __decorate([computed], DetailCriteriaStore.prototype, "detailVariables", null);
  return DetailCriteriaStore;
}(Store);
export { DetailCriteriaStore };